module.exports = __webpack_public_path__ + "img/summer.80767303.jpg";